import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=e59a0178&"
import script from "./form-group.vue?vue&type=script&lang=ts&"
export * from "./form-group.vue?vue&type=script&lang=ts&"
import style0 from "./form-group.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports